<script setup lang="ts">
  import type { ContactData } from '@/models/contact';
  import type { PropType } from 'vue';

  defineProps({
    contactData: {
      type: Object as PropType<ContactData>,
      required: true
    }
  });
</script>

<template>
  <div>
    <div class="contact-info">
      <div v-html="contactData.content" />
    </div>
  </div>
</template>
